import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { useAssertCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { SubscriptionEnum } from "lib/types/graphQLEnums";
import SimplePlanComparisonTable from "./SimplePlanComparisonTable";
import { PlanActionButton } from "./SubscriptionButtons";
import { getStudioPlanDetailsConfig, StudioType } from "./subscriptionPlanDetailsConfig";

import css from "./SubscriptionPlanInfo.module.scss";

export function SubscriptionPlanInfo({
  studioType,
  triggerBookADemoForm,
  triggerDowngradeModal,
  isAnnual = true,
}: {
  studioType: StudioType;
  triggerBookADemoForm: (value: boolean) => void;
  triggerDowngradeModal: (value: boolean) => void;
  isAnnual?: boolean;
}) {
  const currentUser = useAssertCurrentUser();
  const currentPlan = studioType === "bid" ? SubscriptionEnum.Freemium : currentUser.subscription;

  const studioConfig = getStudioPlanDetailsConfig(studioType, isAnnual)[studioType];

  return (
    <div id="planComparisonSection">
      <table className={css.planTable}>
        <thead className={css.planHeader}>
          <tr>
            <FeatureNameHeaderCell scope="col">
              <Flex column gap={8}>
                <Text h1>Compare plans</Text>
                <Subtitle>{studioConfig.audience}</Subtitle>
              </Flex>
            </FeatureNameHeaderCell>
            {studioConfig.headers.map((header) => (
              <th scope="col" className={css.planHeaderCell} key={header.priceInfo}>
                <div className={css.planNames}>
                  <Text>{header.name}</Text>
                  <span className={css.billingInfo}>{header.priceInfo}</span>
                  <PlanActionButton
                    plan={header.type}
                    currentPlan={currentPlan}
                    tableHeader
                    triggerBookADemoForm={triggerBookADemoForm}
                    triggerDowngradeModal={triggerDowngradeModal}
                    dataType={studioType === "bid" ? "BIDS" : undefined}
                    annualPlan={header.type === SubscriptionEnum.Basic ? isAnnual : undefined}
                  />
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <SimplePlanComparisonTable sections={studioConfig.sections} />
      </table>
    </div>
  );
}

const Subtitle = styled(Text)(({ theme }) => ({
  fontSize: "17px",
  color: theme.colors.sysTextSecondary,
}));

const FeatureNameHeaderCell = styled.th({
  textAlign: "left",
  width: "50%",
});
